export const exerciseData = {
    'push-ups': {
      name: 'Push-ups',
      category: 'Chest',
      primary: ['chest'],
      secondary: ['triceps']
    },
    'pull-ups': {
      name: 'Pull-ups',
      category: 'Back',
      primary: ['lats'],
      secondary: ['biceps']
    },
    'squats': {
      name: 'Squats',
      category: 'Legs',
      primary: ['quadriceps'],
      secondary: ['glutes']
    },
    'lunges': {
      name: 'Lunges',
      category: 'Legs',
      primary: ['quadriceps'],
      secondary: ['glutes']
    },
    'deadlifts': {
      name: 'Deadlifts',
      category: 'Back',
      primary: ['lower_back'],
      secondary: ['glutes', 'hamstring']
    },
    'shoulder-press': {
      name: 'Shoulder Press',
      category: 'Shoulders',
      primary: ['shoulder'],
      secondary: ['triceps']
    },
    'bicep-curls': {
      name: 'Bicep Curls',
      category: 'Arms',
      primary: ['biceps'],
      secondary: []
    },
    'tricep-dips': {
      name: 'Tricep Dips',
      category: 'Arms',
      primary: ['triceps'],
      secondary: ['chest']
    },
    'plank': {
      name: 'Plank',
      category: 'Core',
      primary: ['rectus_abdominis'],
      secondary: ['oblique']
    },
    'russian-twists': {
      name: 'Russian Twists',
      category: 'Core',
      primary: ['oblique'],
      secondary: ['rectus_abdominis']
    },
    'mountain-climbers': {
      name: 'Mountain Climbers',
      category: 'Core',
      primary: ['rectus_abdominis'],
      secondary: ['quadriceps']
    },
    'dead-bug': {
      name: 'Dead Bug',
      category: 'Core',
      primary: ['rectus_abdominis'],
      secondary: ['lower_back']
    },
    'bicycle-crunches': {
      name: 'Bicycle Crunches',
      category: 'Core',
      primary: ['rectus_abdominis', 'oblique'],
      secondary: ['quadriceps']
    },
    'bench-press': {
      name: 'Bench Press',
      category: 'Chest',
      primary: ['chest'],
      secondary: ['triceps']
    },
    'incline-press': {
      name: 'Incline Press',
      category: 'Chest',
      primary: ['chest'],
      secondary: ['shoulder']
    },
    'lat-pulldowns': {
      name: 'Lat Pulldowns',
      category: 'Back',
      primary: ['lats'],
      secondary: ['biceps']
    },
    'rows': {
      name: 'Rows',
      category: 'Back',
      primary: ['lats'],
      secondary: ['traps', 'biceps']
    },
    'lateral-raises': {
      name: 'Lateral Raises',
      category: 'Shoulders',
      primary: ['shoulder'],
      secondary: []
    },
    'leg-press': {
      name: 'Leg Press',
      category: 'Legs',
      primary: ['quadriceps'],
      secondary: ['glutes']
    },
    'calf-raises': {
      name: 'Calf Raises',
      category: 'Legs',
      primary: ['calves'],
      secondary: []
    },
    'leg-curls': {
      name: 'Leg Curls',
      category: 'Legs',
      primary: ['hamstring'],
      secondary: []
    },
    'hip-thrusts': {
      name: 'Hip Thrusts',
      category: 'Glutes',
      primary: ['glutes'],
      secondary: ['hamstring']
    },
    'overhead-press': {
      name: 'Overhead Press',
      category: 'Shoulders',
      primary: ['shoulder'],
      secondary: ['triceps']
    },
    'dumbbell-flyes': {
      name: 'Dumbbell Flyes',
      category: 'Chest',
      primary: ['chest'],
      secondary: []
    },
    'cable-flyes': {
      name: 'Cable Flyes',
      category: 'Chest',
      primary: ['chest'],
      secondary: ['shoulder']
    },
    'decline-press': {
      name: 'Decline Press',
      category: 'Chest',
      primary: ['chest'],
      secondary: ['triceps']
    },
    'chest-dips': {
      name: 'Chest Dips',
      category: 'Chest',
      primary: ['chest'],
      secondary: ['triceps', 'shoulder']
    },
    't-bar-rows': {
      name: 'T-Bar Rows',
      category: 'Back',
      primary: ['lats', 'traps'],
      secondary: ['biceps']
    },
    'face-pulls': {
      name: 'Face Pulls',
      category: 'Back',
      primary: ['traps'],
      secondary: ['shoulder']
    },
    'reverse-flyes': {
      name: 'Reverse Flyes',
      category: 'Back',
      primary: ['traps'],
      secondary: ['shoulder']
    },
    'rear-delt-flyes': {
      name: 'Rear Delt Flyes',
      category: 'Shoulders',
      primary: ['shoulder'],
      secondary: ['traps']
    },
    'upright-rows': {
      name: 'Upright Rows',
      category: 'Shoulders',
      primary: ['shoulder', 'traps'],
      secondary: ['biceps']
    },
    'arnold-press': {
      name: 'Arnold Press',
      category: 'Shoulders',
      primary: ['shoulder'],
      secondary: ['triceps']
    },
    'hammer-curls': {
      name: 'Hammer Curls',
      category: 'Arms',
      primary: ['biceps'],
      secondary: []
    },
    'close-grip-bench': {
      name: 'Close-Grip Bench Press',
      category: 'Arms',
      primary: ['triceps'],
      secondary: ['chest']
    },
    'skull-crushers': {
      name: 'Skull Crushers',
      category: 'Arms',
      primary: ['triceps'],
      secondary: []
    },
    'bulgarian-split-squats': {
      name: 'Bulgarian Split Squats',
      category: 'Legs',
      primary: ['quadriceps'],
      secondary: ['glutes']
    },
    'romanian-deadlifts': {
      name: 'Romanian Deadlifts',
      category: 'Legs',
      primary: ['hamstring'],
      secondary: ['glutes', 'lower_back']
    },
    'leg-extensions': {
      name: 'Leg Extensions',
      category: 'Legs',
      primary: ['quadriceps'],
      secondary: []
    },
    'hanging-leg-raises': {
      name: 'Hanging Leg Raises',
      category: 'Core',
      primary: ['rectus_abdominis'],
      secondary: ['oblique']
    },
    'wood-chops': {
      name: 'Wood Chops',
      category: 'Core',
      primary: ['oblique'],
      secondary: ['rectus_abdominis']
    },
    'side-planks': {
      name: 'Side Planks',
      category: 'Core',
      primary: ['oblique'],
      secondary: ['rectus_abdominis']
    },
    'lateral-lunges': {
      name: 'Lateral Lunges',
      category: 'Legs',
      primary: ['abductor', 'quadriceps'],
      secondary: ['glutes']
    },
    'clamshells': {
      name: 'Clamshells',
      category: 'Legs',
      primary: ['abductor'],
      secondary: ['glutes']
    },
    'side-lying-leg-lifts': {
      name: 'Side-Lying Leg Lifts',
      category: 'Legs',
      primary: ['abductor'],
      secondary: []
    },
    'lateral-band-walks': {
      name: 'Lateral Band Walks',
      category: 'Legs',
      primary: ['abductor'],
      secondary: ['glutes']
    },
    'wrist-curls': {
      name: 'Wrist Curls',
      category: 'Arms',
      primary: ['forearms'],
      secondary: []
    },
    'reverse-wrist-curls': {
      name: 'Reverse Wrist Curls',
      category: 'Arms',
      primary: ['forearms'],
      secondary: []
    },
    'farmers-walk': {
      name: 'Farmers Walk',
      category: 'Arms',
      primary: ['forearms'],
      secondary: ['traps', 'shoulder']
    },
    'plate-pinches': {
      name: 'Plate Pinches',
      category: 'Arms',
      primary: ['forearms'],
      secondary: []
    },
    'dead-hangs': {
      name: 'Dead Hangs',
      category: 'Arms',
      primary: ['forearms'],
      secondary: ['lats']
    }
  };